import type { GridFilterModel, GridFilterOperator } from '@repo/go-table';

import type { TAutoAnomaliesFieldConfig, TAutoAnomaliesFilterKeys } from './AUTO_ANOMALIES_FIELD_CONFIG';
import { AUTO_ANOMALIES_FIELD_CONFIG } from './AUTO_ANOMALIES_FIELD_CONFIG';

const FILTER_OPERATORS_WITHOUT_VALUE = new Set(['isEmpty', 'isNotEmpty']);

export const isApplicableFilterItem = (item: GridFilterModel['items'][number]): boolean => {
  if (FILTER_OPERATORS_WITHOUT_VALUE.has(item.operator)) {
    return true;
  }

  const { value } = item;

  if (value == null) {
    return false;
  }

  if (typeof value === 'string') {
    return value.trim() !== '';
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  return true;
};

export const getColumCapabilities = (field: TAutoAnomaliesFilterKeys) => {
  const config = AUTO_ANOMALIES_FIELD_CONFIG[field];
  const filterable = config?.filterable ?? false;

  return {
    filterable,
    sortable: config?.sortable ?? false,
    filterOperators: getFilterOperators(config, filterable),
  };
};

export const getFilterOperators = (config: TAutoAnomaliesFieldConfig, filterable: boolean): GridFilterOperator[] => {
  if (filterable || !config?.filterOperators) {
    return config.filterOperators.map((operator) => ({
      value: operator,
      label: operator,
      requiresFilterValue: !FILTER_OPERATORS_WITHOUT_VALUE.has(operator),
      getApplyFilterFn: () => null,
    }));
  }

  return [];
};

export const getApiField = (field: TAutoAnomaliesFilterKeys): string => {
  return AUTO_ANOMALIES_FIELD_CONFIG[field].apiField;
};
